import { useEffect, useState } from 'react';
import * as maskFuncsByType from './useMask.utils';
import {
  EventArg,
  UseMaskArgs,
  MaskFuncs,
  ReturnUseMaskHook,
} from './useMask.types';

export const useMask = ({
  value,
  onChange,
  onBlur,
  opts,
}: UseMaskArgs): ReturnUseMaskHook => {
  const [maskedValue, setMaskedValue] = useState('');
  const [unmaskedValue, setUnmaskedValue] = useState(value);

  const setStrRaw = (maskFuncs: MaskFuncs, value: string): string => {
    const reverseValue = maskFuncs.reverseMaskedValue(value, opts);
    setMaskedValue(maskFuncs.getMaskedValue(reverseValue, opts));
    setUnmaskedValue(reverseValue);
    return reverseValue;
  };
  const setStr = setStrRaw.bind(null, maskFuncsByType[opts.type]);
  useEffect(() => {
    setStr(value);
  }, [value]);
  const handleChange = (event: EventArg): void => {
    const { value } = event.currentTarget;
    const valueToSet = setStr(value);
    event.currentTarget.value = valueToSet;
    onChange(event);
  };
  const handleBlur = (event: EventArg): void => {
    event.currentTarget.value = unmaskedValue;
    onBlur && onBlur(event);
  };
  return {
    unmaskedValue,
    maskedValue,
    onChange: handleChange,
    onBlur: handleBlur,
  };
};
